/**
 * Whether this build serves the `/preview` design harness.
 *
 * `true` here, so local serves (`npm run start:demo`, `npm start`), canary and
 * RC builds (`ng build --c=development`) have it. The `production`
 * configuration swaps in `preview-enabled.production.ts` through angular.json
 * `fileReplacements`, so NEXT and PROD never ship it. See AGENTS.md § Preview.
 */
export const PREVIEW_ENABLED: boolean = true;
